import Image from '@base/Image';

import {
  StaticInfoOfferingsWrapper,
  SubHeading,
  OfferingWrapper,
  OfferingText
} from './styles';

const StaticInfoOfferings = ({ cmsData }) => {
  if (!cmsData) return null;
  const { selectionPage: { offerings, offeringsHeading } = {} } = cmsData;

  return (
    <StaticInfoOfferingsWrapper>
      <SubHeading>{offeringsHeading}</SubHeading>
      {offerings?.map((offering, index) => (
        <OfferingWrapper key={String(index)}>
          <Image
            src="offline-centres/bullet-checkbox.svg"
            width={20}
            height={20}
            alt="check rounded"
          />
          <OfferingText>{offering}</OfferingText>
        </OfferingWrapper>
      ))}
    </StaticInfoOfferingsWrapper>
  );
};

export default StaticInfoOfferings;
